export const volumes = [
  {
    number: 1,
    tint: "#FFF4CF",
    ink: "#7A5200",
    title: "Autism Communication Foundations Blueprint™",
    subtitle: "Understand Communication Differences and Organize Individualized Support Priorities.",
    intro: [
      "Before selecting activities or preparing visual materials, it’s important to understand the different ways autistic children may communicate.",
      "This volume introduces a neurodiversity-affirming framework for organizing communication-related information while respecting individual preferences, autonomy, and communication differences.",
    ],
    items: [
      "An introduction to communication differences in autism.",
      "Verbal, nonspeaking, multimodal, and AAC-supported communication.",
      "Functional communication and everyday participation.",
      "Considerations for communication access and sensory preferences.",
      "Strengths-based communication observation worksheets.",
      "Planning frameworks for identifying individual priorities.",
      "Practical questions to guide collaborative discussions.",
    ],
    takeaway: "A clearer foundation for organizing communication support around the individual child.",
    note: "",
  },
  {
    number: 2,
    tint: "#E4F6EB",
    ink: "#0B6B35",
    title: "Functional Communication Assessment Roadmap™",
    subtitle: "Organize Communication Observations Before Choosing Your Next Support Strategy.",
    intro: [
      "Meaningful communication support begins with understanding how a child currently communicates across different situations.",
      "This volume provides practical educational tools for organizing observations of communication functions, preferences, interaction opportunities, and environmental factors.",
    ],
    items: [
      "Functional communication observation worksheets.",
      "Communication opportunity mapping templates.",
      "Everyday interaction recording guides.",
      "Communication function reference charts.",
      "Environmental barrier identification checklists.",
      "Child preference and interest documentation tools.",
      "Questions to support individualized assessment discussions.",
    ],
    takeaway: "A more structured way to document relevant communication information and identify what requires further exploration.",
    note: "These worksheets support observation and planning; they are not standardized diagnostic instruments.",
  },
  {
    number: 3,
    tint: "#FFEBD9",
    ink: "#9A4300",
    title: "Visual Communication Support Blueprint™",
    subtitle: "Plan Visual Resources That Support Meaningful Everyday Communication.",
    intro: [
      "Visual communication supports can help make information accessible and create additional opportunities for expression and participation.",
      "This volume focuses on organizing visual resources according to the child’s individual communication needs, preferences, and access requirements.",
    ],
    items: [
      "Communication board planning templates.",
      "Visual choice board examples.",
      "Daily routine visual support organizers.",
      "Activity-based communication resources.",
      "Core and activity-specific vocabulary planning sheets.",
      "Visual accessibility considerations.",
      "Adaptation checklists for different settings.",
    ],
    takeaway: "Practical starting points for preparing visual communication materials without designing every resource from scratch.",
    note: "",
  },
  {
    number: 4,
    tint: "#FDE6F0",
    ink: "#A3195B",
    title: "AAC Planning & Personalization Roadmap™",
    subtitle: "Organize Individualized AAC Support Considerations With Greater Clarity.",
    intro: [
      "AAC can provide important communication opportunities for children who benefit from additional ways to express themselves.",
      "This volume introduces practical frameworks for organizing AAC planning considerations in collaboration with qualified professionals and communication partners.",
    ],
    items: [
      "AAC planning worksheets.",
      "Unaided and aided communication support concepts.",
      "Low-tech and high-tech AAC considerations.",
      "Communication access planning guides.",
      "Vocabulary organization frameworks.",
      "AAC personalization documentation templates.",
      "Communication partner collaboration checklists.",
    ],
    takeaway: "A structured reference for organizing AAC-related planning questions and individualized support considerations.",
    note: "AAC selection and implementation require individualized assessment and appropriate professional involvement.",
  },
  {
    number: 5,
    tint: "#EFE7FC",
    ink: "#5B2DB3",
    title: "Everyday Communication Implementation Blueprint™",
    subtitle: "Bring Communication Opportunities Into Home, School, Play & Daily Routines.",
    intro: [
      "Communication support should not be limited to isolated exercises.",
      "This volume helps you organize opportunities for meaningful communication throughout the child’s everyday activities.",
    ],
    items: [
      "Communication opportunity planning for daily routines.",
      "Play-based interaction examples.",
      "Classroom participation support worksheets.",
      "Home communication activity organizers.",
      "Communication partner modeling concepts.",
      "Interest-based communication planning templates.",
      "Practical participation observation tools.",
    ],
    takeaway: "A more organized approach to planning communication opportunities across everyday environments.",
    note: "",
  },
  {
    number: 6,
    tint: "#DDF5F2",
    ink: "#0B6A61",
    title: "Communication Progress & Collaboration Roadmap™",
    subtitle: "Document Observations, Coordinate Support & Plan Your Next Steps.",
    intro: [
      "Communication development and participation are individual processes.",
      "This volume focuses on organizing follow-up information, documenting environmental adjustments, and supporting collaboration between professionals and communication partners.",
    ],
    items: [
      "Communication support follow-up templates.",
      "Participation observation records.",
      "Collaborative planning worksheets.",
      "Family and educator discussion guides.",
      "Communication support adjustment checklists.",
      "Documentation organization tools.",
      "Next-step planning frameworks.",
    ],
    takeaway: "A consistent way to organize observations, collaborative decisions, and future planning priorities.",
    note: "",
  },
];
